module.exports = __webpack_public_path__ + "static/media/3.60e3a41e.jpg";